import React from "react";

import "./InfoBox.scss";

export default function InfoBox({ children }: { children: React.ReactNode }) {
    return <div className="bwp-info-box">{children}</div>;
}
